import React from "react";

export const CityPortalBanner: React.FC = () => {
  return (
    <header className="bg-neutral-950 text-neutral-50 border-b border-neutral-900">
      <div className="mx-auto max-w-5xl px-4 py-6">
        <div className="space-y-1">
          <h1 className="text-2xl font-semibold">
            City of Reedley
          </h1>
          <p className="text-sm text-neutral-300">
            Water & Wastewater Operations Portal
          </p>
        </div>

        <div className="mt-4 border-l-4 border-amber-400 bg-neutral-50 text-neutral-900 shadow-sm">
          <div className="px-4 py-2 text-sm leading-snug">
            <p className="font-medium">
              Pilot System — Operational Records Platform
            </p>
            <p className="text-xs text-neutral-700">
              Used for evaluation and continuous improvement
            </p>
          </div>
        </div>
      </div>
    </header>
  );
};
